import { api } from "../index";
import { NotificationsCreateDto, NotificationsDto } from "./dto/notifications.dto";

const NOTIFICATIONS_ENDPOINT = "/notifications";

export const NotificationsAPI = api.injectEndpoints({
	endpoints: build => ({
		getNotificationsSubscriptions: build.query<{ subscriptions: NotificationsDto[] }, { id: string; email: string }>({
			query: ({ id, email }) => ({
				url: `${NOTIFICATIONS_ENDPOINT}/${id}/subscriptions`,
				params: { email },
				method: "GET"
			}),
			providesTags: ["notificationsSubscriptions"]
		}),
		getDeviceSubscription: build.query<
			{ subscribed: boolean; device: string; os: string; browser: string },
			{ id: string; email: string; anonymous_token: string }
		>({
			query: ({ id, email, anonymous_token }) => ({
				url: `${NOTIFICATIONS_ENDPOINT}/${id}/subscription`,
				params: { email, anonymous_token },
				method: "GET"
			}),
			providesTags: ["notificationsSubscription"]
		}),
		subscribeToNotifications: build.mutation<{ success: boolean }, NotificationsCreateDto>({
			query: ({ invitationId, ...body }) => ({
				url: `${NOTIFICATIONS_ENDPOINT}/${invitationId}/subscribe`,
				method: "POST",
				body
			}),
			invalidatesTags: ["notificationsSubscriptions", "notificationsSubscription"]
		}),
		unSubscribeToNotifications: build.mutation<{ success: boolean }, Partial<NotificationsCreateDto>>({
			query: ({ invitationId, ...body }) => ({
				url: `${NOTIFICATIONS_ENDPOINT}/${invitationId}/unSubscribe`,
				method: "PUT",
				body
			}),
			invalidatesTags: ["notificationsSubscriptions", "notificationsSubscription"]
		})
	})
});

export const {
	useSubscribeToNotificationsMutation,
	useLazyGetDeviceSubscriptionQuery,
	useLazyGetNotificationsSubscriptionsQuery,
	useUnSubscribeToNotificationsMutation
} = NotificationsAPI;
